export function formatAmount(amount: string | null, currency: string | null): string {
  if (amount === null) return '—';
  const n = Number.parseFloat(amount);
  if (!Number.isFinite(n)) return amount;
  return currency === null ? n.toFixed(2) : `${n.toFixed(2)} ${currency}`;
}
